module.exports = __webpack_public_path__ + "static/img/bg-es.fc405f8d.png";